import { render, staticRenderFns } from "./Generate.vue?vue&type=template&id=62dc66c6"
import script from "./Generate.vue?vue&type=script&lang=js"
export * from "./Generate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62dc66c6')) {
      api.createRecord('62dc66c6', component.options)
    } else {
      api.reload('62dc66c6', component.options)
    }
    module.hot.accept("./Generate.vue?vue&type=template&id=62dc66c6", function () {
      api.rerender('62dc66c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/tax_return/Generate.vue"
export default component.exports